import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import MainPage from './MainPage.js';
import About from './About.js';
import PdfViewer from './PdfViewer.js';

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/pdf-viewer" element={<PdfViewer />} />
        </Routes>
    </Router>
  );
}

export default App;
